<template>
  <div class="my-4 w-full px-4 md:px-6 lg:px-8">
    <div
      class="flex w-full items-center gap-2 overflow-x-auto overflow-y-hidden rounded-lg bg-white p-2 hide-scrollbar xl:bg-transparent xl:p-0"
    >
      <FormInput
        v-model="store.state.searchTerm"
        type="search"
        placeholder="Search Applicants"
        class="w-full sm:w-80"
        style="min-width: 16rem"/>
      <FormSelectDropdown v-model="store.state.filterStatus" placeholder="Select" :options="STATUS_OPTIONS"
                          class="ml-auto w-44 scale-95"/>
      <RouterLink to="/opportunities">
        <FormButton size="md" color="gradient" class="whitespace-nowrap">Find More Job Opportunities</FormButton>
      </RouterLink>
    </div>
  </div>
</template>
<script setup>
import FormButton from "./FormButton.vue";
import FormInput from "./FormInput.vue";
import FormSelectDropdown from "./FormSelectDropdown.vue";
import {useCandidateApplicationStore} from "../stores/CandidateApplicationStore.js";

const store = useCandidateApplicationStore();

const STATUS_OPTIONS = [
  "All Applications",
  "Active Only",
  "Disqualified Only",
  "Withdrawn Only",
];
</script>
